/* eslint-disable no-useless-catch */
/* eslint-disable import/no-unresolved */
import API_URLS from "src/config/API_URLS";
import axiosInstance from "src/utils/Axios/axiosInstance";
import StorageService from "src/utils/Storage/storageService";

export const getLeadInfo = async (leadId: any) => {
  try {
    const response: any = await axiosInstance.get(`${API_URLS.leadUrl}${leadId}`);
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

export const setMemberDetails = async (memberId: string, body: Record<string, any>) => {
  const obj = { ...body };
  delete obj.jointCoBorrowerFlag;
  delete obj.jointHousewifeFlag;
  delete obj.jointGuarantorFlag;
  delete obj.jointPrimaryBorrowerFlag;
  try {
    const response: any = await axiosInstance.patch(`${API_URLS.setMember}/${memberId}`, obj);
    return response;
  } catch (response: any) {
    throw new Error(response?.message);
  }
};

export const getReviewDetails = async (leadId: string) => {
  try {
    const response: any = await axiosInstance.get(`${API_URLS.getReviewDetails}${leadId}`, {
      headers: {
        token: StorageService.getFromLocalStorage("verificationToken")
      }
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

export const recalculatePremium = async (leadId: string) => {
  try {
    const response: any = await axiosInstance.get(`${API_URLS.recalculatePremium}${leadId}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const setJointMemberDetails = async (body: Record<string, any>) => {
  try {
    const response: any = await axiosInstance.put(`${API_URLS.setMember}`, body);
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

export const setProportionateMemberDetails = async (body: Record<string, any>) => {
  try {
    const { leadId, ...restPayload } = body;
    const response: any = await axiosInstance.put(
      `${API_URLS.setProportionate}/${leadId}`,
      restPayload
    );
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};
